import { toggle } from "./toggle";

export default toggle("demo-dependents-enabled");
